import React from 'react';
import Icon, { HomeOutlined } from '@ant-design/icons';
import { Space } from 'antd';
import type { GetProps } from 'antd';

type CustomIconComponentProps = GetProps<typeof Icon>;

const SquareSvg = () => (
    <svg width="1em" height="1em" fill="currentColor">
        <title>seed icon</title>
        <rect width="100" height="100" fill="currentColor" />
    </svg>
);

export const SquareSeedIcon = (props: Partial<CustomIconComponentProps>) => (
    <Icon component={SquareSvg} {...props} />
  );